// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__Q45Ew","approved":"Status_approved__28Paa","rejected":"Status_rejected__fKM-f","expired":"Status_expired__yTl0o","label":"Status_label__2hnAL"};